import { useTranslation } from "react-i18next";
import { useDeleteApiAccountFavoritesByFavoriteListIdMutation } from "api/generatedApi";
import { ResultDialogType, useMutation } from "utils/hooks/use-mutation";
import { useToast } from "shared/toast/hooks/use-toast";
import { useConfirm } from "components/shared/alert/confirm/hooks/use-confirm";

interface Props {
  listId: string;
  isOwner: boolean;
}

export function useDeleteFavoriteList(props: Props) {
  const { listId, isOwner } = props;
  const { t } = useTranslation();
  const toast = useToast();
  const [deleteFavoriteList] = useDeleteApiAccountFavoritesByFavoriteListIdMutation();

  const wrapMutation = useMutation({
    successProps: {
      description: t("account.favorites.listToastDeleteSuccess"),
    },
    resultDialogType: ResultDialogType.Toast,
  });

  const handleOnSubmit = () => {
    wrapMutation(
      deleteFavoriteList({
        favoriteListId: listId,
      })
    );
  };

  const openConfirmDialog = useConfirm({
    title: t("account.favorites.deleteListTitle"),
    description: t("account.favorites.deleteListDescription"),
    submitButtonLabel: t("common.delete"),
    submit: handleOnSubmit,
  });

  const handleClick = () => {
    if (!isOwner) {
      toast.error(t("account.favorites.cannotDeleteNotOwnerList"));
      return;
    }
    openConfirmDialog();
  };

  return handleClick;
}
